import { RootState } from '../store';

export const pastLocationSelector = (state: RootState) =>
  state.locationHistory.pastLocations;

export const isExitAppSelector = (state: RootState) =>
  state.locationHistory.pastLocations.length <= 1;
